import {h, Fragment} from "preact"
import { usePagination, useActions, useAppState } from "@nosto/preact";
import Icon from "./elements/Icon";

function PageLink({ onClick, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ${className}`}
            href="javascript:void(0)"
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    );
}

export default function Pagination() {
    const { current, prev, first, pages, last, next, totalPages } = usePagination({
        width: 5
    });

    const { updateSearch } = useActions();
    const { response } = useAppState()


    function setPageCallback(from) {
        return () => {
            updateSearch({ products: { from } });
            scrollTo(0, 0);
        };
    }

    return (
        <div class="ns-pagination-container">
         {response.products.total > 24 && (
                <ul class="ns-pagination-items">
                <li class="ns-first-wrapper">
                    <PageLink onClick={setPageCallback(0)} class="ns-to-first" ariaLabel="First">
                    </PageLink>
                </li>

                <li class={prev ? "ns-prev-btn" : "ns-prev-disabled"}>
                    <PageLink onClick={prev && setPageCallback(prev.from)} className="ns-previous" ariaLabel="Previous">
                       Prev
                    </PageLink>
                </li>

                {current.page >= 4 && (
                    <li class="ns-pagination-item">
                        <PageLink onClick={setPageCallback(0)} ariaLabel="First">1</PageLink>
                    </li>
                )}

                {current.page >= 5 && (
                    <li class="ns-pagination-item ns-dots">
                        <span class="ns-d-block">...</span>
                    </li>
                )}


                {
                    pages.map((page) => (
                        <li class={`${page.current ? "ns-current-item" : "ns-pagination-item"}`}>
                            <PageLink onClick={setPageCallback(page.from)}>{page.page}</PageLink>
                        </li>
                    ))
                }

                {(totalPages - current.page > 1 && (
                    <li class="ns-pagination-item ns-dots">
                        <span class="ns-d-block">...</span>
                    </li>
                ))}

                {totalPages - current.page > 2 && (
                    <li class="ns-pagination-item">
                        <PageLink onClick={last && setPageCallback(last.from)} ariaLabel="Last">{totalPages}</PageLink>
                    </li>
                )}

                <li class={next ? "ns-next-btn" : "ns-next-disabled"}>
                    <PageLink onClick={next && setPageCallback(next.from)} className="ns-next" ariaLabel="Next">
                        Next
                    </PageLink>
                </li>

                <li class="ns-last-wrapper">
                    <PageLink onClick={setPageCallback((totalPages - 1) * 40)} class="ns-to-last" ariaLabel="Last">
                    </PageLink>
                </li>
            </ul>
         )}
            <div class="ns-pagination-text">
                    {current.page} out of {totalPages} page{totalPages > 1 && 's'}
            </div>
        </div>
    );
}